import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import DonationListing from '../DonationListing/DonationListing';
import EventPage from '../EventPage/EventPage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';
import AnnouncementsPage from '../AnnouncementsPage/AnnouncementsPage';
import FilesPage from '../FilesPage/FilesPage';
import PrivacyPage from '../PrivacyPage/PrivacyPage';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import RouteMeta from '../../components/RouteMeta/RouteMeta';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <RouteMeta />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="donation-listing" element={<DonationListing />} />
          <Route path="events" element={<EventPage />} />
          <Route path="announcements" element={<AnnouncementsPage />} />
          <Route path="files" element={<FilesPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="blog-details/:slug" element={<BlogDetails />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
